var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6923 12.1335C14.1026 12.5711 14.1026 13.2548 13.6923 13.6923C13.2548 14.1026 12.5711 14.1026 12.1335 13.6923L8.87911 10.4106C7.75785 11.149 6.39046 11.5319 4.91367 11.3404C2.39767 10.9849 0.373926 8.93381 0.0457518 6.44515C-0.419162 2.72584 2.72584 -0.419162 6.44515 0.0457518C8.93381 0.373926 10.9849 2.39767 11.3404 4.91367C11.5319 6.39046 11.149 7.75785 10.4106 8.85176L13.6923 12.1335ZM2.17889 5.67941C2.17889 7.62111 3.73771 9.17994 5.67941 9.17994C7.59376 9.17994 9.17994 7.62111 9.17994 5.67941C9.17994 3.76506 7.59376 2.17889 5.67941 2.17889C3.73771 2.17889 2.17889 3.76506 2.17889 5.67941Z",
    fill: "#996CFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.769978c594f2811b626e4d843207889e.svg";
export { ForwardRef as ReactComponent };